import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import LamaList from "../pages/Residential/Optional/Lama/LamaList";

import {
    fetchLamaForms,
    deleteLamaForm,
} from "../store/slices/lamaFormsSlice";

const Lama = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { lamaForms, isLoading } = useSelector(
        (state) => state.lamaForms
    );

    useEffect(() => {
        dispatch(fetchLamaForms());
    }, [dispatch]);

    const handleAdd = () => {
        navigate("/residential/optional/lama-form/add");
    };

    const handleEdit = (id) => {
        navigate(`/residential/optional/lama-form/edit/${id}`);
    };

    const handleDelete = async (id) => {
        await dispatch(deleteLamaForm(id)).unwrap();
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body p-0">
                        <LamaList
                            records={lamaForms}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default Lama;
